import { createSelector } from '@reduxjs/toolkit';

import { getModelConceptClassValue } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectClassRelationshipsSelector } from 'src/selectors/projectClassRelationships';
import { projectMappingSelector } from 'src/selectors/projectMapping';
import { ReduxState } from 'src/store/types';

export const projectMappingRelationshipsSelector = memoizeSelectorFactory(
  (projectId: string, mappingId: string | undefined) =>
    createSelector(
      projectMappingSelector(projectId, mappingId),
      (state: ReduxState) => state,
      (mapping, state) => {
        if (!mapping || !mapping.to) {
          return {};
        }

        const classIri = getModelConceptClassValue(mapping.to);
        return projectClassRelationshipsSelector(projectId, classIri)(state);
      }
    )
);
